import { useState } from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Copy, Check, ExternalLink } from 'lucide-react';
import { idToSlug } from '../util/slug';

export const ShareLinksDialog = ({ open, onOpenChange, shareableId }) => {

  console.log(shareableId);
  const [copiedTimer, setCopiedTimer] = useState(false);
  const [copiedResults, setCopiedResults] = useState(false);
  const slug = idToSlug(shareableId);
  const baseUrl = window.location.origin;
  const timerUrl = `${window.location.origin}/public/timer/${slug}`;





  const resultsUrl = `${window.location.origin}/public/results/${slug}`;

  const copyToClipboard = (text, type) => {
    navigator.clipboard.writeText(text);
    if (type === 'timer') {
      setCopiedTimer(true);
      setTimeout(() => setCopiedTimer(false), 2000);
    } else {
      setCopiedResults(true);
      setTimeout(() => setCopiedResults(false), 2000);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl bg-white border-gray-200 shadow-xl max-w-md">
        <DialogHeader className='pb-4 border-b border-gray-200'>
          <DialogTitle>Share Competition</DialogTitle>
          <DialogDescription>
            Share these links with the public to view live competition data
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-6 py-4">
          {/* Timer Link */}
          <div className="space-y-2">
            <Label htmlFor="timer-link">Competition Timer (Public View)</Label>
            <div className="flex gap-2">
              <Input
                id="timer-link"
                value={timerUrl}
                readOnly
                className="font-mono text-sm"
              />
              <Button
                variant="outline"
                size="icon"
                onClick={() => copyToClipboard(timerUrl, 'timer')}
              >
                {copiedTimer ? (
                  <Check className="size-4 text-green-600" />
                ) : (
                  <Copy className="size-4" />
                )}
              </Button>
              <Button
                variant="outline"
                size="icon"
                onClick={() => window.open(timerUrl, '_blank')}
              >
                <ExternalLink className="size-4" />
              </Button>
            </div>
            <p className="text-xs text-gray-500">
              Live view of boulder timers and current climbers
            </p>
          </div>

          {/* Results Link */}
          <div className="space-y-2">
            <Label htmlFor="results-link">Results (Public View)</Label>
            <div className="flex gap-2">
              <Input
                id="results-link"
                value={resultsUrl}
                readOnly
                className="font-mono text-sm"
              />
              <Button
                variant="outline"
                size="icon"
                onClick={() => copyToClipboard(resultsUrl, 'results')}
              >
                {copiedResults ? (
                  <Check className="size-4 text-green-600" />
                ) : (
                  <Copy className="size-4" />
                )}
              </Button>
              <Button
                variant="outline"
                size="icon"
                onClick={() => window.open(resultsUrl, '_blank')}
              >
                <ExternalLink className="size-4" />
              </Button>
            </div>
            <p className="text-xs text-gray-500">
              Live scores and competition results
            </p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};